import React from "react";

/**
 * Mobile-friendly key/value data row. Composed vertically like `<dl>`.
 * @param {Object} props
 * @param {React.ReactNode} props.label
 * @param {React.ReactNode} props.value
 */
export function DataListRow({ label, value }) {
  return (
    <div className="ds-data-list-row">
      <span className="label">{label}</span>
      <span style={{ fontFamily: "var(--font-mono)", fontVariantNumeric: "tabular-nums lining-nums" }}>{value}</span>
    </div>
  );
}
